// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__MgnBb","rotate":"styles_rotate__FqoI0","path":"styles_path__IPGsE","dash":"styles_dash__TQZYL","color":"styles_color___sJCw"};